import React from 'react';
import DropdownMenu from "../desktop-components/ApplicationMenubar";
import '../applications-css/Application.css'
import "../applications-css/Paint.css";

class Paint extends React.Component {
  constructor(props) {
    super(props);
    let filename = this.props.filename;
    if(filename != null) {
      filename = this.extensionStripper(filename);
    }
    this.state = {
      filename: filename,
      currentlyDrawing: false,
      drawMode: "paintbrush",
      drawColor: "black",
      drawWidth: 3,
      drawOpacity: 1,
      imageSize: 500,
      commands: [],
      currentLine: [],
    }
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this.newFile = this.newFile.bind(this);
    this.newFileHandler = this.newFileHandler.bind(this);
    this.openFile = this.openFile.bind(this);
    this.openFileHandler = this.openFileHandler.bind(this);
    this.saveFile = this.saveFile.bind(this);
    this.saveAndClearFile = this.saveAndClearFile.bind(this);
    this.saveFileHandler = this.saveFileHandler.bind(this);
    this.undoHandler = this.undoHandler.bind(this);
    this.redrawCanvas = this.redrawCanvas.bind(this);
    this.mousedownHandler = this.mousedownHandler.bind(this);
    this.mousemoveHandler = this.mousemoveHandler.bind(this);
    this.mouseoutHandler = this.mouseoutHandler.bind(this);
    this.mouseupHandler = this.mouseupHandler.bind(this);
    this.opacityHandler = this.opacityHandler.bind(this);
    this.sizeHandler = this.sizeHandler.bind(this);
    this.colorPickHandler = this.colorPickHandler.bind(this);
  }

  componentDidMount() {
    this.refs.canvasContent.addEventListener('mousedown', this.mousedownHandler);
    this.refs.canvasContent.addEventListener('mouseup', this.mouseupHandler);
    if(this.props.filename != null) {
      let canvas = this.refs.canvasContent;
      let canvas2d = canvas.getContext("2d");
      canvas2d.clearRect(0, 0, this.state.imageSize, this.state.imageSize);
      let newContents = sessionStorage.getItem(this.props.filename);
      let newImage = new Image();
      newImage.onload = function(){
        canvas2d.drawImage(newImage, 0, 0);
      }
      newImage.src = newContents;
    }
  }

  componentWillUnmount() {
    this.refs.canvasContent.removeEventListener('mousedown', this.mousedownHandler);
    this.refs.canvasContent.removeEventListener('mousemove', this.mousemoveHandler);
    this.refs.canvasContent.removeEventListener('mouseleave', this.mouseoutHandler);
    this.refs.canvasContent.removeEventListener('mouseup', this.mouseupHandler);
  }

  opacityHandler(modifier) {
    let newOpacity = this.state.drawOpacity + modifier;
    if(newOpacity <= 0) {
      newOpacity = 0;
    }
    if(newOpacity >= 1) {
      newOpacity = 1;
    }
    this.setState({
      drawOpacity: newOpacity
    });
  }

  sizeHandler(modifier) {
    let newWidth = this.state.drawWidth + modifier;
    if(newWidth <= 0) {
      newWidth = 1;
    }
    this.setState({
      drawWidth: newWidth
    });
  }

  colorPickHandler(color) {
    this.setState({
      drawColor: color
    });
  }

  mousePosition(canvas, e) {
    let viewportWidth = this.props.width - 100;
    let viewportHeight = this.props.height;
    let viewportSize = (viewportWidth > viewportHeight) ? viewportHeight : viewportWidth;
    let scaler = this.state.imageSize / viewportSize;
    let bounds = canvas.getBoundingClientRect();
    return {
      x: (e.clientX - bounds.left) * scaler,
      y: (e.clientY - bounds.top) * scaler
    }
  }

  mousedownHandler(e) {
    let canvas = this.refs.canvasContent;
    let canvas2d = canvas.getContext("2d");
    // get mouse coords
    let mouseCoords = this.mousePosition(canvas, e);
    // moveTo() to set drawing cursot
    canvas2d.moveTo(mouseCoords.x, mouseCoords.y);
    // beginPath() to start path
    canvas2d.beginPath();
    this.refs.canvasContent.addEventListener('mousemove', this.mousemoveHandler);
    this.setState({
      currentlyDrawing: true
    });
  }

  mousemoveHandler(e) {
    if(this.state.currentlyDrawing === true) {
      this.refs.canvasContent.addEventListener('mouseleave', this.mouseoutHandler);
      let canvas = this.refs.canvasContent;
      let canvas2d = canvas.getContext("2d");
      // add new points with lineTo()
      let mouseCoords = this.mousePosition(canvas, e);
      canvas2d.lineTo(mouseCoords.x, mouseCoords.y);
      // color in with stroke()
      canvas2d.strokeStyle = this.state.drawColor;
      canvas2d.lineWidth = this.state.drawWidth;
      canvas2d.globalAlpha = this.state.drawOpacity;
      canvas2d.stroke();

      let newPointArray = this.state.currentLine;
      // save x, y, color, size, opacity
      newPointArray.push(
        {
          x: mouseCoords.x,
          y: mouseCoords.y,
          color: this.state.drawColor,
          width: this.state.drawWidth,
          opacity: this.state.drawOpacity,
        }
      );
    }
  }

  mouseoutHandler(e) {
    // stop drawing
    this.refs.canvasContent.removeEventListener('mousemove', this.mousemoveHandler);
    if(this.state.currentlyDrawing === true) {
      let newCommandList = this.state.commands;
      newCommandList.push(this.state.currentLine);
      this.setState({
        currentlyDrawing: false,
        currentLine: [],
      })
    }
  }

  mouseupHandler(e) {
    // stop drawing
    this.refs.canvasContent.removeEventListener('mousemove', this.mousemoveHandler);
    if(this.state.currentlyDrawing === true) {
      let newCommandList = this.state.commands;
      newCommandList.push(this.state.currentLine);
      this.setState({
        currentlyDrawing: false,
        currentLine: [],
      })
    }
  }

  undoHandler(e) {
    if(this.state.commands.length > 0) {
      let newCommandList = this.state.commands;
      let undidCommand = newCommandList.pop();
      console.log(undidCommand);
      this.setState(
        {
          commands: newCommandList,
        },
        function() {
          this.redrawCanvas();
        }
      );
    }
  }

  redrawCanvas() {
    let canvas = this.refs.canvasContent;
    let canvas2d = canvas.getContext("2d");
    canvas2d.clearRect(0, 0, this.state.imageSize, this.state.imageSize);
    for (let i = 0; i < this.state.commands.length; i++) {
      let initialPoint = this.state.commands[i][0];
      canvas2d.strokeStyle = initialPoint.color;
      canvas2d.lineWidth = initialPoint.drawWidth;
      canvas2d.globalAlpha = initialPoint.drawOpacity;
      canvas2d.moveTo(initialPoint.x, initialPoint.y);
      canvas2d.beginPath();
      for (let j = 0; j < this.state.commands[i].length; j++) {
        let point = this.state.commands[i][j];
        canvas2d.lineTo(point.x, point.y);
        canvas2d.stroke();
      }
    }
  }

  extensionStripper(filename) {
    let periodIndex = filename.lastIndexOf(".");
    if(periodIndex === -1) {
      return filename;
    }
    let name = filename.slice(0, periodIndex);
    console.log(name);
    return name;
  }

  newFile(e, mode) {
    if(mode === "save") {
      this.props.appLauncherHandler(e, "Save File", this.saveAndClearFile, this.state.filename);
    }
    if(mode === "discard") {
      let canvas = this.refs.canvasContent;
      let canvas2d = canvas.getContext("2d");
      this.setState({
        filename: null,
        commands: [],
        currentLine: [],
      });
      canvas2d.clearRect(0, 0, this.state.imageSize, this.state.imageSize);
    }
  }

  newFileHandler(e) {
    this.props.appLauncherHandler(e, "New File", this.newFile, this.state.filename);
  }

  openFileError() {
    return(
      <span>
        <img width="32" src={this.props.warning_icon} draggable="false" alt={"Error"}/>
        <p>The file is not openable by Paint.</p>
      </span>
    );
  }

  openFile(fullFilename, filename, filetype) {
    if(filetype !== "png") {
      this.props.appLauncherHandler(null, "Popup Window", this.openFileError);
    }
    else {
      this.setState(
        {
          filename: filename,
          commands: [],
          currentLine: [],
        }
      );
      let canvas = this.refs.canvasContent;
      let canvas2d = canvas.getContext("2d");
      canvas2d.clearRect(0, 0, this.state.imageSize, this.state.imageSize);
      let newContents = sessionStorage.getItem(fullFilename);
      let newImage = new Image();
      newImage.onload = function(){
        canvas2d.drawImage(newImage, 0, 0);
      }
      newImage.src = newContents;
    }
  }

  openFileHandler(e) {
    this.props.appLauncherHandler(e, "Open File", this.openFile, this.state.filename);
  }

  saveFile(fullFilename) {
    let filename = this.extensionStripper(fullFilename);
    console.log(filename);
    this.setState(
      {
        filename: filename,
        commands: [],
        currentLine: [],
      },
      function() {
        let contents = this.refs.canvasContent.toDataURL();
        sessionStorage.setItem(this.state.filename + ".png", contents);
      }
    );
  }

  saveAndClearFile(fullFilename) {
    let filename = this.extensionStripper(fullFilename);
    this.setState(
      {
        filename: filename,
        commands: [],
        currentLine: [],
      },
      function() {
        let canvas = this.refs.canvasContent;
        let contents = canvas.toDataURL();
        sessionStorage.setItem(this.state.filename + ".png", contents);
        let canvas2d = canvas.getContext("2d");
        this.setState({filename: null});
        canvas2d.clearRect(0, 0, this.state.imageSize, this.state.imageSize);
      }
    );
  }

  saveFileHandler(e) {
    this.props.appLauncherHandler(e, "Save File", this.saveFile, this.state.filename);
  }

  aboutHandler() {
    return(
      <span>
        <img width="32" src={this.props.info_icon} draggable="false" alt={"Info"}/>
        <p>It's a regular painting application.</p>
      </span>
    );
  }

  helpHandler() {
    return(
      <span>
        <img width="32px" src={this.props.info_icon} draggable="false" alt={"Info"}/>
        <p> Just draw stuff and save it. </p>
      </span>
    );
  }

  render() {
    let dpi = window.devicePixelRatio;
    let viewportWidth = this.props.width - 100;
    let viewportHeight = this.props.height;
    let viewportSize = (viewportWidth > viewportHeight) ? viewportHeight : viewportWidth;
    return(
      <div id="paintWrapper" className="outsideWrapper">
        <MenuBar
          appLauncherHandler = {this.props.appLauncherHandler}
          newFileHandler = {this.newFileHandler}
          openFileHandler = {this.openFileHandler}
          saveFileHandler = {this.saveFileHandler}
          undoHandler = {this.undoHandler}
          aboutHandler = {this.aboutHandler}
          helpHandler = {this.helpHandler}
        />
        <div id="paintBottomSection">
          <SideBar
            drawWidth = {this.state.drawWidth}
            drawOpacity = {this.state.drawOpacity}
            colorPickHandler = {this.colorPickHandler}
            opacityHandler = {this.opacityHandler}
            sizeHandler = {this.sizeHandler}
          />
          <div id="paintCanvas">
            <canvas
              id="canvas" ref="canvasContent"
              width={this.state.imageSize}
              height={this.state.imageSize}

              style={{
                width: viewportSize * dpi,
                height: viewportSize * dpi
              }}> </canvas>
          </div>
        </div>
      </div>
    )
  }
}

function MenuBar(props) {
  return (
    <div id="menuBar">
      <DropdownMenu
        buttonLabel = "File"
        menuItems = {[{name: "New", onClick: e => props.newFileHandler(e)},
                      {name: "Open", onClick: e => props.openFileHandler(e)},
                      {name: "Save", onClick: e => props.saveFileHandler(e)}]}
      />
      <DropdownMenu
        buttonLabel = "Edit"
        menuItems = {[{name: "Undo", onClick: e => props.undoHandler(e)}]}
      />
      <DropdownMenu
        buttonLabel = "Help"
        menuItems = {[{name: "About", onClick: e => props.appLauncherHandler(e, "Popup Window", props.aboutHandler)},
                      {name: "Help", onClick: e => props.appLauncherHandler(e, "Popup Window", props.helpHandler)}]}
      />
    </div>
  );
}

class SideBar extends React.Component {
  constructor(props) {
    super(props);
    this.opacityHandler = this.opacityHandler.bind(this);
    this.sizeHandler = this.sizeHandler.bind(this);
    this.colorPickHandler = this.colorPickHandler.bind(this);
  }

  opacityHandler(modifier) {
    this.props.opacityHandler(modifier);
  }

  sizeHandler(modifier) {
    this.props.sizeHandler(modifier);
  }

  colorPickHandler(color) {
    this.props.colorPickHandler(color);
  }

  colorPickerGenerator() {
    let colorPickHandler = this.colorPickHandler;
    let colors = ["black", "white", "#DE1B11", "#DD6D05", "#DCBD00", "#77ED32", "#77ED32",
                  "#37ED46", "#36ED94", "#35ECDE", "#3CB2EE", "#4069EF", "#5F39EF", "#A639EE"]
    return(

      <div className="sideBarGrid">
        {colors.map(function(color, index) {
            return(
              <ColorSquare
                color = {color}
                colorPickHandler = {colorPickHandler}
                key={index}
              />
            );
        })}
      </div>
    )
  }

  render() {
    return (
      <div id="paintSideBar">
        <nav>colors:</nav>
        {this.colorPickerGenerator()}
        <nav>size: {this.props.drawWidth}</nav>
        <div className="sideBarGrid">
          <button id="colorSquare"
            onClick = {() => this.sizeHandler(-1)}> -
          </button>
          <button id="colorSquare"
            onClick = {() => this.sizeHandler(1)}> +
          </button>
        </div>
        <nav>opacity: {this.props.drawOpacity.toFixed(1)}</nav>
        <div className="sideBarGrid">
          <button id="colorSquare"
            onClick = {() => this.opacityHandler(-0.1)}> -
          </button>
          <button id="colorSquare"
            onClick = {() => this.opacityHandler(0.1)}> +
          </button>
        </div>
      </div>
    );
  }
}

class ColorSquare extends React.Component {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler() {
    this.props.colorPickHandler(this.props.color);
  }

  render() {
    return (
      <button id="colorSquare"
        onClick = {() => this.clickHandler()}
        style={{
          backgroundColor: this.props.color,
        }}>
      </button>
    )
  }
}

export default Paint;
